import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import BackToTop from './BackToTop';
import ScrollManager from './ScrollManager';
import ChatSupportNotice from './ChatSupportNotice';

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <ScrollManager />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
      <ChatSupportNotice />
    </div>
  );
}